//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/mixins/global'
import axios, {
  CancelToken
} from 'axios'

export default {
  props: {
    po_pending: String,
    po_vi: String,
    po_non: String,
    so_no_doc: String,
    target_wk: String,
    target_date: String,
    bu: String,
    rm_type: String,
    grp: String

  },
  data() {
    return {
      po: null,
      complete: null,
      pending: null,
      medium: false,
      polist: [],
      polistitem: [],
      polistclosed: [],
      visible1: false,
      visible2: false,
    }
  },
  created() {
    this.getPO()
  },
  mounted() {

  },
  methods: {
    getPO() {

      //   let params = new FormData()
      //   params.append("so_no_doc", this.so_no_doc)
      //   params.append("rm_type", this.rm_type)
      //   params.append("bu", this.bu)

      //   await axios({
      //     method: "post",
      //     url: this.$api + "readinessWIP.php/poPending",
      //     data: params
      //   }).then(res => {
      //     console.log(this.so_no_doc, res.data.CNT_PENDING)
      //     this.po = res.data.CNT_PO
      //     this.complete = res.data.CNT_COMPLETE
      //     this.pending = res.data.CNT_PENDING
      //   })
      this.LoadPOList()
      this.LoadPOListClosed()
    },

    LoadPOList() {
      this.polist = []
      this.visible1 = true
      let params = new FormData()
      params.append("so_no_doc", this.so_no_doc)
      params.append("rm_type", this.rm_type)
      params.append("bu", this.bu)
      params.append("grp", this.grp)

      axios({
        method: "post",
        url: this.$apiFix + "readinessWIP.php/getPOList2021",
        data: params
      }).then(res => {
        console.log(res.data)
        this.polist = res.data
        this.visible1 = false
      })
    },

    LoadPOListClosed() {
      this.visible2 = true
      this.polistclosed = []
      let params = new FormData()
      params.append("so_no_doc", this.so_no_doc)
      params.append("rm_type", this.rm_type)
      params.append("bu", this.bu)
      params.append("grp", this.grp)
      axios({
        method: "post",
        url: this.$api + "readinessWIP.php/getPOListClosed",
        data: params
      }).then(res => {
        // console.log(res.data)
        this.polistclosed = res.data
        this.visible2 = false
      })
    },

    // LoadPOListItem(obj) {
    //   // console.log(pono)
    //   let params = new FormData()
    //   params.append("so_no_doc", this.so_no_doc)
    //   params.append("po_no_doc", obj.PO_NO_DOC)
    //   params.append("rm_type", this.rm_type)
    //   params.append("bu", this.bu)
    //   axios({
    //     method: "post",
    //     url: this.$api + "readinessWIP.php/getPOListItem",
    //     data: params
    //   }).then(res => {
    //     // console.log(res.data)
    //     obj.ARRAYITEMS = res.data
    //   })
    // }

  }
}
